import { type ReactNode } from 'react';
import { getInventoryDate, useNextOrderV3 } from '@hungryroot/orders';
import { type ProductDetail } from '@hungryroot/rest';
import { type GetProductParams } from '@hungryroot/rest/api/v2/products/[id]/get';
import { useProduct } from '../../hooks/useProduct';

interface ProductLoaderProps {
  id: number;
  children: (props: { product?: ProductDetail }) => ReactNode;
}

export function ProductLoader(props: ProductLoaderProps) {
  const { id, children } = props;
  const params: GetProductParams = {
    productId: id,
  };
  const { order } = useNextOrderV3();
  if (order?.inventory_date || order?.cutoff_datetime) {
    params['inventory_date'] = getInventoryDate(order);
  }

  if (order?.origin) {
    params['origin'] = order.origin;
  }

  const { data: product } = useProduct(params, { enabled: !!id });

  return children({ product });
}
